'use client';
import React from 'react';

import styled from 'styled-components';

import { ProfileItem } from './ProfilesList';
import Icon from '@/ui/components/Icon';

const DownloadLinkButton = styled.a`
  background-color: ${({ theme }) => theme.custom.colors.brand};
  color: white;
  border: none;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  font-weight: normal;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  min-width: 120px;
`;

const Text = styled.div`
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  word-wrap: break-word;
  padding-right: 0.5rem;
`;

const Wrapper = styled.article`
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  padding: 0.75rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: stretch;

  h3 {
    margin: 0;
  }
`;

// const IconWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-right: 0.5rem;
// `;

interface DownloadProfileItemProps {
  profile: ProfileItem;
}

export default function DownloadProfileItem({
  profile,
}: DownloadProfileItemProps) {
  return (
    <Wrapper>
      <Text>
        <h3>{profile.name}</h3>
        {profile.description}
        <div></div>
      </Text>
      <DownloadLinkButton href={profile.offline_archive_url} target="_blank">
        <Icon name="download" size="xl" />
      </DownloadLinkButton>
    </Wrapper>
  );
}
